<script lang="ts">
    export let data;
</script>

<div class="overflow-y h-full w-full">
    <pre>
        {JSON.stringify(data, null, 2)}
    </pre>
</div>
